module.exports = __webpack_public_path__ + "img/bk.29114cfe.jpg";